import React, {useEffect, useState} from 'react';
import SupportSearch from "../components/support-search";
import VideoSearch from "../components/video-search";
import MainSupportSearch from "../components/main-support-search";



/**
 * the entry point
 */
const App: React.FC = () => {
    const [isMainSupportType, setIsMainSupportType] = useState(false);
    const [isSupportType, setIsSupportType] = useState(false);
    const [isVideoType, setIsVideoType] = useState(false);



    /**
     * On page load - init url patams, query search results ( if searchtext param is not null)
     */
    useEffect(() => {
        const $searchTypeEl = document.querySelector('[data-search-type]');

       if($searchTypeEl){
            let searchType = $searchTypeEl.getAttribute('data-search-type') ?? '';
            if(searchType === "support"){
                setIsSupportType(true);
            }else if(searchType === "main-support"){
                setIsMainSupportType(true);
            }else if(searchType === "video"){
                setIsVideoType(true);
            }
        }
    }, []);


    return (
            <>
                {isSupportType && <SupportSearch />}
                {isMainSupportType && <MainSupportSearch />}
                {isVideoType && <VideoSearch />}
            </>
    );
};

export default App;

